module.exports = {
  returnName: {
    1: 'AditivoReducaoCarencias',
    2: 'BoletoPagamentoOperadoraAnterior',
    3: 'CadastroPessoaFisica',
    4: 'CartaProprioPunho',
    5: 'CartaoNacionalSaude',
    6: 'CarteiraConvenioOperadoraAnterior',
    7: 'CarteiraProfissaoVinculadaEntidadeClasse',
    8: 'CertidaoCasamento',
    9: 'CertidaoNascimento',
    10: 'ComprovanteEndereco',
    11: 'ComprovantePagamentoFiliacaoEntidadeClasse',
    12: 'ComprovantePagamentoOperadoraAnterior',
    13: 'DecisaoJudicial',
    14: 'DeclaracaoAdministradoraEntidadeComprovandoVinculo',
    15: 'DeclaracaoFaculdadeAtualizada',
    16: 'DeclaraçãoImpostoRenda',
    17: 'DeclaracaoPermanenciaOperadoraAnterior',
    18: 'DeclaracaoSaude',
    19: 'DeclaracaoUniãoEstavel',
    20: 'FichaFiliacaoEntidadeClasse',
    21: 'LaudoINSS',
    22: 'PropostaAdesao',
    23: 'RegistroGeral',
    24: 'RelatorioCompatibilidade',
  },
  returnNameFormatted: {
    1: 'Aditivo de Redução de Carências',
    2: 'Boleto de Pagamento da Operadora Anterior',
    3: 'Cadastro de Pessoa Física',
    4: 'Carta de próprio punho',
    5: 'Cartão Nacional de Saúde',
    6: 'Carteira Convênio da Operadora Anterior',
    7: 'Carteira da Profissão vinculada à Entidade de Classe',
    8: 'Certidão de casamento',
    9: 'Certidão de nascimento',
    10: 'Comprovante de Endereço',
    11: 'Comprovante de Pagamento da Filiação à Entidade de Classe',
    12: 'Comprovante de Pagamento Operadora Anterior',
    13: 'Decisão judicial',
    14: 'Declaração da Administradora/Entidade Comprovando Vinculo',
    15: 'Declaração da faculdade atualizada',
    16: 'Declaração de imposto de renda',
    17: 'Declaração de Permanência da Operadora Anterior',
    18: 'Declaração de Saúde',
    19: 'Declaração de união estável',
    20: 'Ficha de Filiação à Entidade de Classe',
    21: 'Laudo INSS',
    22: 'Proposta de Adesão',
    23: 'Registro Geral',
    24: 'Relatório de Compatibilidade',
  },
  returnId: {
    AditivoReducaoCarencias: 1,
    BoletoPagamentoOperadoraAnterior: 2,
    CadastroPessoaFisica: 3,
    CartaProprioPunho: 4,
    CartaoNacionalSaude: 5,
    CarteiraConvenioOperadoraAnterior: 6,
    CarteiraProfissaoVinculadaEntidadeClasse: 7,
    CertidaoCasamento: 8,
    CertidaoNascimento: 9,
    ComprovanteEndereco: 10,
    ComprovantePagamentoFiliacaoEntidadeClasse: 11,
    ComprovantePagamentoOperadoraAnterior: 12,
    DecisaoJudicial: 13,
    DeclaracaoAdministradoraEntidadeComprovandoVinculo: 14,
    DeclaracaoFaculdadeAtualizada: 15,
    DeclaraçãoImpostoRenda: 16,
    DeclaracaoPermanenciaOperadoraAnterior: 17,
    DeclaracaoSaude: 18,
    DeclaracaoUniãoEstavel: 19,
    FichaFiliacaoEntidadeClasse: 20,
    LaudoINSS: 21,
    PropostaAdesao: 22,
    RegistroGeral: 23,
    RelatorioCompatibilidade: 24,
  },
  returnNameForName: {
    AditivoReducaoCarencias: 'AditivoReducaoCarencias',
    BoletoPagamentoOperadoraAnterior: 'BoletoPagamentoOperadoraAnterior',
    CadastroPessoaFisica: 'CadastroPessoaFisica',
    CartaProprioPunho: 'CartaProprioPunho',
    CartaoNacionalSaude: 'CartaoNacionalSaude',
    CarteiraConvenioOperadoraAnterior: 'CarteiraConvenioOperadoraAnterior',
    CarteiraProfissaoVinculadaEntidadeClasse:
      'CarteiraProfissaoVinculadaEntidadeClasse',
    CertidaoCasamento: 'CertidaoCasamento',
    CertidaoNascimento: 'CertidaoNascimento',
    ComprovanteEndereco: 'ComprovanteEndereco',
    ComprovantePagamentoFiliacaoEntidadeClasse:
      'ComprovantePagamentoFiliacaoEntidadeClasse',
    ComprovantePagamentoOperadoraAnterior:
      'ComprovantePagamentoOperadoraAnterior',
    DecisaoJudicial: 'DecisaoJudicial',
    DeclaracaoAdministradoraEntidadeComprovandoVinculo:
      'DeclaracaoAdministradoraEntidadeComprovandoVinculo',
    DeclaracaoFaculdadeAtualizada: 'DeclaracaoFaculdadeAtualizada',
    DeclaraçãoImpostoRenda: 'DeclaraçãoImpostoRenda',
    DeclaracaoPermanenciaOperadoraAnterior:
      'DeclaracaoPermanenciaOperadoraAnterior',
    DeclaracaoSaude: 'DeclaracaoSaude',
    DeclaracaoUniãoEstavel: 'DeclaracaoUniãoEstavel',
    FichaFiliacaoEntidadeClasse: 'FichaFiliacaoEntidadeClasse',
    LaudoINSS: 'LaudoINSS',
    PropostaAdesao: 'PropostaAdesao',
    RegistroGeral: 'RegistroGeral',
    RelatorioCompatibilidade: 'RelatorioCompatibilidade',
  },
  returnNamePorSigla: {
    ARC: 'AditivoReducaoCarencias',
    BPOA: 'BoletoPagamentoOperadoraAnterior',
    CPF: 'CadastroPessoaFisica',
    RDP: 'CartaProprioPunho',
    CNS: 'CartaoNacionalSaude',
    CCO: 'CarteiraConvenioOperadoraAnterior',
    CP: 'CarteiraProfissaoVinculadaEntidadeClasse',
    CC: 'CertidaoCasamento',
    CN: 'CertidaoNascimento',
    CE: 'ComprovanteEndereco',
    CPEC: 'ComprovantePagamentoFiliacaoEntidadeClasse',
    CPOA: 'ComprovantePagamentoOperadoraAnterior',
    DJ: 'DecisaoJudicial',
    CV: 'DeclaracaoAdministradoraEntidadeComprovandoVinculo',
    DFA: 'DeclaracaoFaculdadeAtualizada',
    DIR: 'DeclaraçãoImpostoRenda',
    DPO: 'DeclaracaoPermanenciaOperadoraAnterior',
    DS: 'DeclaracaoSaude',
    DUE: 'DeclaracaoUniãoEstavel',
    FF: 'FichaFiliacaoEntidadeClasse',
    LI: 'LaudoINSS',
    PA: 'PropostaAdesao',
    RG: 'RegistroGeral',
    RCA: 'RelatorioCompatibilidade',
    CCOA: 'CarteiraConvenioOperadoraAnterior',
    CCA: 'CONTRATO',
    HOL: 'holerites',
    TRES: 'TermoRescisao',
    CARCON: 'CartaConcessaoINSS',
  },
  returnNameFormattedPorSigla: {
    ARC: 'Aditivo de Redução de Carências',
    BPOA: 'Boleto de Pagamento da Operadora Anterior',
    CPF: 'Cadastro de Pessoa Física',
    RDP: 'Carta de próprio punho',
    CNS: 'Cartão Nacional de Saúde',
    CCO: 'Carteira Convênio da Operadora Anterior',
    CP: 'Carteira da Profissão vinculada à Entidade de Classe',
    CC: 'Certidão de casamento',
    CN: 'Certidão de nascimento',
    CE: 'Comprovante de Endereço',
    CPEC: 'Comprovante de Pagamento da Filiação à Entidade de Classe',
    CPOA: 'Comprovante de Pagamento Operadora Anterior',
    DJ: 'Decisão judicial',
    CV: 'Declaração da Administradora/Entidade Comprovando Vinculo',
    DFA: 'Declaração da faculdade atualizada',
    DIR: 'Declaração de imposto de renda',
    DPOA: 'Declaração de Permanência da Operadora Anterior',
    DS: 'Declaração de Saúde',
    DUE: 'Declaração de união estável',
    FF: 'Ficha de Filiação à Entidade de Classe',
    LI: 'Laudo INSS',
    PA: 'Proposta de Adesão',
    RG: 'Registro Geral',
    RCA: 'Relatório de Compatibilidade',
    CCOA: 'Carteira Convênio da Operadora Anterior',
    CCA: 'CONTRATO (carimbado e assinado)',
    HOL: '03 últimos holerites e/ou comprovação de contribuição',
    TRES: 'Termo de rescisão',
    CARCON: 'Carta de Concessão do INSS',
  },
};
